import {NgModule} from '@angular/core';
import {StationChargePointPipe} from './stationChargePoint.pipe';
import {PowerMaxInWToKwPipe} from './powerMaxInWToKw.pipe';
import {DurationPipe} from './duration.pipe';
import {KilometerToDistanceImpurePipe} from './kilometerToDistanceImpure.pipe';
import {LinkifyPipe} from './linkify.pipe';
import {LocationPipe} from './location.pipe';
import {PowerInWToKwPipe} from './powerInWToKw.pipe';
import {EnergyPipe} from './energy.pipe';
import {OtpSessionPipe} from './eventDetails/otpSession.pipe';
import {ChargeRecordPipe} from './eventDetails/chargeRecord.pipe';
import {ReservationDetailPipe} from './eventDetails/reservationDetail.pipe';
import {FaqMailSubjectPipe} from './faq/faqMailSubject.pipe';
import {ChargeRecordMediaDisplayNamePipe} from './chargeRecordMediaDisplayName.pipe';

// Please keep this alphabetically sorted
const PIPES = [
    ChargeRecordMediaDisplayNamePipe,
    ChargeRecordPipe,
    DurationPipe,
    EnergyPipe,
    FaqMailSubjectPipe,
    KilometerToDistanceImpurePipe,
    LinkifyPipe,
    LocationPipe,
    OtpSessionPipe,
    PowerInWToKwPipe,
    PowerMaxInWToKwPipe,
    ReservationDetailPipe,
    StationChargePointPipe
];

@NgModule({
    declarations: PIPES,
    exports: PIPES,
    providers: PIPES
})
export class FrontPipesModule {

}
